import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var useTranslation = function useTranslation(translations) {
  return {
    t: function t(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Object.entries(options).reduce(function (s, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          propName = _ref2[0],
          propValue = _ref2[1];
        return s.replace("{{".concat(propName, "}}"), propValue);
      }, translations[key]);
    }
  };
};
export default useTranslation;